<template>
  <header>
    <div class="container-fluid sub-header">
      <div class="row">
        <div class="col-auto mr-auto">
          <div class="container-fluid">
            <div class="btn-group">
              <select v-model="language" @change="onChange($event)">
                <option value="ja">日本語</option>
                <option value="en">English</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid main-header">
      <div class="row">
        <div class="col-sm-12 col-auto">
          <nav class="navbar navbar-expand-lg navbar-light">
            <div class="container-fluid">
              <a class="navbar-brand" href="/">
                <img src="../assets/images/logo.png" class="img-fluid logo" alt="img">
              </a>
              <ul class="nav navbar-nav navbar-right" v-if="user">
                <li><h6 class="my-auto my-md-3 mx-3">{{language === 'ja' ? 'こんにちは' : 'Hi'}} {{user ? user.person_id : 'there'}}</h6></li>
                <li><span class="button" @click="logout">{{language === 'ja' ? 'ログアウト' : 'Log out'}}</span></li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'Navbar',
  computed: {
    ...mapState({
      user: (state) => state.user,
    })
  },
  data() {
    return {
      language: "ja"
    };
  },
  methods: {
    onChange(event) {
      this.$store.commit('setSiteLanguage', this.language)
    },
    logout() {
      this.$store.commit('logout')
      this.$router.push('/').catch(err => {})
    },
    start() {
      this.$router.push('/surveyView')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
